//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { isProductType } from '@motionelements/core/src/services/catalog.service.js';
import channelTypesMixin from '@motionelements/core/src/components/mixins/channelTypes.mixin.js';
import { listChannelPopularElements } from '@/api/channels.js';

export default {
  name: 'DiscoverMore',
  props: {
    mediaTypeId: String,
  },
  mixins: [channelTypesMixin],
  components: {
    ProductCard: () => import('@motionelements/core/src/components/product-card/ProductCard.vue'),
    ProductCardAudio: () => import('@motionelements/core/src/components/product-card/ProductCardAudio.vue'),
    ProductCardLoader: () => import('@motionelements/core/src/components/product-card/ProductCardLoader.vue'),
  },
  data() {
    return {
      isLoading: false,
      elements: [],
      perPage: 6,
    };
  },
  mounted() {
    if (this.isAudio) {
      this.perPage = 4;
    }
    this.elementsList();
  },
  computed: {
    isAudio() {
      return isProductType('audio', this.mediaTypeId);
    },
  },
  methods: {
    elementsList() {
      this.isLoading = true;
      listChannelPopularElements(this.mediaTypeId, {
        perPage: this.perPage,
        free: 0,
      })
        .then((response) => {
          this.elements = response.data.data;
        })
        .catch((e) => {
          console.warn(e);
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    mediaTypeTitle(mediaTypeId) {
      return this.getChannelTypeName(mediaTypeId);
    },
  },
};
